import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {ReferenceInput, Title} from 'react-admin';
import {downloadFile, NotifyForm, schoolYears, showErrorNotify, TreeCheckboxInput} from '../../components';
import env from '../../env';

class CustomerCertificateBatchTemplate extends React.Component {
    state = {
        unitIds: [],
        schoolYearId: schoolYears[0].id,
    };

    getReportUrl = () => {
        downloadFile(`${env.baseURL}/api/certificateBatchTemplate?` +
            `unitIds=` + this.state.unitIds, 'chung_chi_nhan_vien.zip')
    }


    billBatchTemplateAllClazzes = () => {
        if (!this.state.unitIds || this.state.unitIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách phòng ban")
            return;
        }
        this.getReportUrl()
    }

    validate = (values) => {
        const errors = {};
        this.setState({
            unitIds: values.unitIds
        })
        return errors;
    }

    onSchoolYearChanged(e, value) {
        this.setState({
            schoolYearId: value,
            changeSchoolYear: true
        });
    }

    render() {
        return (
            <Card>
                <Title title="resources.certificateBatchTemplate.name"/>
                <CardContent>
                    <NotifyForm params={this.state}
                                validate={this.validate}
                                allClazzes={this.billBatchTemplateAllClazzes}
                    >
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <label>Danh sách phòng ban *</label>
                                <div style={{maxHeight: '400px', overflow: 'auto'}}>
                                    <ReferenceInput source="unitIds"
                                                    reference="units"
                                                    perPage={999}
                                                    filter={{
                                                        departmentWithParents: true
                                                    }}
                                                    {...this.props} >
                                        <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
                                    </ReferenceInput>
                                </div>
                            </Grid>
                        </Grid>
                    </NotifyForm>

                </CardContent>
            </Card>
        )
    }
}

export default CustomerCertificateBatchTemplate

